import { DetailedHTMLProps, FC, HTMLAttributes, InputHTMLAttributes } from "react";
import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Poppins', sans-serif;
`;

export const Input: FC<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>> = styled.input`
  height: 40px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;

  font-size: ${(props) => props.theme?.baseFontSize - 1}px;

  flex: 1 1 auto !important;

  border: 1px solid #E0E0E0 !important;
  border-radius: 8px;
  outline: none !important;

  font-family: inherit !important;
  font-feature-settings: inherit !important;
  font-variation-settings: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
  color: #333 !important;
  margin: 0 !important;
  padding: 0 12px !important;
  transition: all 0.3s ease;

  &:focus {
    border-color: ${(props) => props.theme.primary_color} !important;
    box-shadow: 0 0 0 2px ${(props) => props.theme.primary_color}33 !important;
  }

  &::placeholder {
    color: #999;
  }
`;

export const SendButton = styled.button<{ width: string; height: string; }>`
  && {
    width: ${(props) => props.width};
    height: ${(props) => props.height};

    background: none;
    border: none;
    margin-right: 5px;
    border-radius: 50%;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${(props) => props?.theme?.themeConfig?.chatMessages?.sendEmailForm?.color}11;
    }

    &:active {
      transform: scale(0.95);
    }

    & svg {
      width: ${(props) => props.width};
      height: ${(props) => props.height};
      fill: ${(props) => props?.theme?.themeConfig?.chatMessages?.sendEmailForm?.color};
    }

    cursor: pointer;
  }
`;

export const InputGroup: FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = styled.div`
  position: relative;
  width: 70%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  background-color: #F9F9F9;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const ErrorMessage = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff6b6b;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #ff6b6b transparent transparent transparent;
  }
`;
